export default {
  id: 'aliPosterPaymentModal',
  code: 'CN',
  text: {
    'Register': '报名',
    'Payment Successful': '扫码已完成，支付成功',
    'Complete': '完成',
    'Please complete the payment in Alipay and confirm the payment': '请在支付宝界面完成支付，并在此确认是否支付成功',
    'Success': '支付已成功',
    'Cancel': '取消支付',
    'Payment unsuccessful, please try again': '支付未成功，请在试一次',

  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/aliPosterPayment/locale.js